import React, { useState } from "react"

// 开关
export function useSwitch(initialState: boolean) {
    const [open, setOpen] = useState<boolean>(initialState)
    const toggle = (value?: boolean) => {
        if (value !== undefined) {
            setOpen(value)
        } else {
            setOpen(!open)
        }
    }
    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)
    return { open, toggle, handleOpen, handleClose }
}
// 对象
export function useAssign<T>(initial: T) {
    const [object, setObject] = useState<T>(initial)
    const handleChange = (newObject: Partial<T>) => {
        if (newObject === null) {
            setObject(newObject)
        } else {
            setObject({
                ...object,
                ...newObject,
            })
        }
    }
    return { object, handleChange }
}
// 标识
export function useMark<T>(initial: T) {
    const [mark, setMark] = useState<T>(initial)
    const handleChangeMark = (mark: T) => {
        setMark(mark)
    }
    const resetMark = () => {
        setMark(initial)
    }
    return { mark, handleChangeMark, resetMark }
}
// 输入框控件
export function useInputChange(initialText: string) {
    const [text, setText] = useState<string>(initialText)
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setText(event.target.value)
    }
    const clearText = () => {
        setText(initialText)
    }
    return {
        text,
        handleChange,
        clearText,
        setText,
    }
}
// 日期选择
export function useDateChange(initialDate: Date) {
    const [date, setDate] = useState<Date>(initialDate)
    const handleChangeDate = (date: Date) => {
        setDate(date)
    }
    const backToToday = () => {
        setDate(new Date())
    }
    return {
        date,
        handleChangeDate,
        backToToday,
    }
}

// 移入移出
export function useMouseGesture() {
    const [show, setShow] = useState<boolean>(false)
    const handleMouseEnter = (event: React.MouseEvent) => {
        event.stopPropagation()
        setShow(true)
    }
    const handleMouseLeave = (event: React.MouseEvent) => {
        event.stopPropagation()
        setShow(false)
    }
    return {
        show,
        handleMouseEnter,
        handleMouseLeave,
    }
}

// 对象修改
export function useValueMap<T>(initialValue: T) {
    const [map, setMap] = useState<T | null>(initialValue)
    const handleChangeMap = (childMap: T | null) => {
        if (childMap === null) {
            setMap(null)
        } else {
            setMap({
                ...childMap,
            })
        }
    }
    return {
        map,
        handleChangeMap,
    }
}

